module.exports = __webpack_public_path__ + "static/media/tubewatermark.65b3785d.png";